var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: {
        placement: _vm.placement,
        trigger: "manual",
        width: _vm.popoverWidth(),
        "popper-class": "excel-export-popper"
      },
      model: {
        value: _vm.visible,
        callback: function($$v) {
          _vm.visible = $$v
        },
        expression: "visible"
      }
    },
    [
      _c(
        "div",
        [
          _c(
            "div",
            { staticStyle: { display: "none" } },
            [_vm._t("header")],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center justify-content-between"
            },
            [
              _c("h6", { staticClass: "font-weight-bold mb-0" }, [
                _vm._v(_vm._s(_vm.title))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column justify-content-center align-items-center"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "rounded d-flex justify-content-center align-items-center position-relative",
                      style: {
                        width: "32px",
                        height: "32px",
                        borderWidth: "1px",
                        borderStyle: "solid",
                        borderColor: "#c2e7b0",
                        backgroundColor: "#f0f9eb"
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "bi bi-filetype-xls",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            fill: "#67C23A",
                            viewBox: "0 0 16 16"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              d:
                                "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM6.472 15.29a1.2 1.2 0 0 1-.111-.449h.765a.58.58 0 0 0 .254.384q.106.073.25.114.143.041.319.041.246 0 .413-.07a.56.56 0 0 0 .255-.193.5.5 0 0 0 .085-.29.39.39 0 0 0-.153-.326q-.152-.12-.462-.193l-.619-.143a1.7 1.7 0 0 1-.539-.214 1 1 0 0 1-.351-.367 1.1 1.1 0 0 1-.123-.524q0-.366.19-.639.19-.272.527-.422.338-.15.777-.149.457 0 .78.152.324.153.5.41.18.255.2.566h-.75a.56.56 0 0 0-.12-.258.6.6 0 0 0-.247-.181.9.9 0 0 0-.369-.068q-.325 0-.513.152a.47.47 0 0 0-.184.384q0 .18.143.3a1 1 0 0 0 .405.175l.62.143q.326.075.566.211a1 1 0 0 1 .375.358q.135.222.135.56 0 .37-.188.656a1.2 1.2 0 0 1-.539.439q-.351.158-.858.158-.381 0-.665-.09a1.4 1.4 0 0 1-.478-.252 1.1 1.1 0 0 1-.29-.375m-2.945-3.358h-.893L1.81 13.37h-.036l-.832-1.438h-.93l1.227 1.983L0 15.931h.861l.853-1.415h.035l.85 1.415h.908L2.253 13.94zm2.727 3.325H4.557v-3.325h-.79v4h2.487z"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("el-divider", { staticClass: "my-2" }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                "label-position": "top",
                "status-icon": ""
              },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    [
                      !_vm.form.all_date
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "mb-0",
                              attrs: {
                                prop: "periodo",
                                rules: [
                                  {
                                    required: true,
                                    message: "O período é obrigatório",
                                    trigger: "change"
                                  }
                                ]
                              }
                            },
                            [
                              _c("label", [_vm._v("Período")]),
                              _vm._v(" "),
                              _c("el-date-picker", {
                                style: { width: "100%" },
                                attrs: {
                                  "unlink-panels": "",
                                  size: "small",
                                  type: "daterange",
                                  "start-placeholder": "Início",
                                  "end-placeholder": "Fim",
                                  format: "dd/MM/yyyy",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.form.periodo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "periodo", $$v)
                                  },
                                  expression: "form.periodo"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-white border rounded-lg p-2 d-flex align-items-center justify-content-between mt-3 mb-2",
                        style: { gap: "12px" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex align-items-center",
                            style: { gap: "8px" }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                style: { pointerEvents: "none" },
                                attrs: {
                                  type: _vm.form.all_date
                                    ? "success"
                                    : "danger",
                                  plain: "",
                                  circle: "",
                                  size: "mini"
                                }
                              },
                              [
                                _vm.form.all_date
                                  ? _c("i", { staticClass: "el-icon-unlock" })
                                  : _c("i", { staticClass: "el-icon-lock" })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "mb-0 font-weight-bold" },
                              [_vm._v("Todo Período?")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { staticClass: "mb-0", attrs: { prop: "status" } },
                          [
                            _c("el-switch", {
                              attrs: {
                                "active-text": "Sim",
                                "inactive-text": "Não"
                              },
                              model: {
                                value: _vm.form.all_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "all_date", $$v)
                                },
                                expression: "form.all_date"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.$scopedSlots.filters
            ? _c(
                "div",
                { key: _vm.filtersKey, staticClass: "mb-3" },
                [_vm._t("filters", null, { filters: _vm.slotFilters })],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _vm.isAbleToExport
                ? _c("el-col", { staticClass: "mb-3" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-center" },
                      [
                        _c("span", [
                          _c("b", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.data.length) +
                                "\n                            " +
                                _vm._s(
                                  _vm.data.length === 1
                                    ? _vm.singularLabel
                                    : _vm.pluralLabel
                                ) +
                                ".\n                        "
                            )
                          ])
                        ])
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("el-col", [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-end" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          plain: "",
                          size: "large",
                          circle: "",
                          disabled: !_vm.isAbleToExport
                        },
                        on: { click: _vm.reset }
                      },
                      [_c("i", { staticClass: "el-icon-delete" })]
                    ),
                    _vm._v(" "),
                    !_vm.isAbleToExport
                      ? _c(
                          "el-button",
                          {
                            staticClass: "rounded-pill",
                            style: { width: "100%" },
                            attrs: {
                              size: "large",
                              plain: "",
                              disabled: _vm.isLoading
                            },
                            on: { click: _vm.prepare }
                          },
                          [
                            _vm.isLoading
                              ? _c("i", { staticClass: "el-icon-loading" })
                              : _c("i", { staticClass: "el-icon-tickets" }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Preparar relatório")])
                          ]
                        )
                      : _c(
                          "export-excel",
                          {
                            key: _vm.exportKey,
                            staticClass:
                              "el-button el-button--large el-button--success rounded-pill",
                            style: { width: "100%" },
                            attrs: {
                              data: _vm.data,
                              fields: _vm.fields,
                              worksheet: _vm.worksheet,
                              name: _vm.generatedFileName
                            }
                          },
                          [
                            _c("i", { staticClass: "el-icon-tickets" }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Exportar relatório")])
                          ]
                        )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          ref: "reference",
          attrs: { slot: "reference" },
          on: {
            click: function($event) {
              _vm.visible = !_vm.visible
            }
          },
          slot: "reference"
        },
        [
          _vm._t("reference", function() {
            return [
              _c(
                "el-button",
                {
                  style: {
                    height: "32px",
                    paddingBlock: "2px"
                  },
                  attrs: { type: "success", plain: "", round: "" }
                },
                [
                  _c("i", { staticClass: "el-icon-tickets" }),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.buttonLabel) +
                      "\n                "
                  ),
                  _c("i", { staticClass: "el-icon-arrow-down ml-2" })
                ]
              )
            ]
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b7c69b00", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7c69b00","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_micro/Excel/ExcelExport.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-b7c69b00","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_micro/Excel/ExcelExport.vue
// module chunks = 2